import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';

import extract5 from './extract-5.png';
import fullworkflow from './fullworkflow.png';
import eComm3 from './eComm_3.png';
import gsParts from './gs-parts.png';
import CaseStudy1 from './components/CaseStudy1';
import CaseStudy2 from './components/CaseStudy2';
import CaseStudy3 from './components/CaseStudy3';
import CaseStudy4 from './components/CaseStudy4';

function HomePage() {
  return (
    <div className="App">
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-left">
            <h2>Madison Falcone</h2>
            <p className="subtext padding-top-12">Defining + Building + Designing</p>
          </div>
          <div className="hero-right">
            <div className="hero-links">
              {/* <a href="#" className="hero-link">Resume</a> */}
              <a href="https://www.linkedin.com/in/madisonannborgmann/" className="hero-link">LinkedIn</a>
              <a href="https://medium.com/@mborgmann" className="hero-link">Writings</a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="projects-container">
        <h2 className="projects-title">Projects:</h2>
        
        <div className="home-case-study-section">
          <div className="case-study-image">
            <div className="image-container">
              <img src={extract5} alt="Case Study 1" />
            </div>
          </div>
          <div className="home-case-study-content">
            <h2>Using DocAI to reduce manual data entry and improve Loan Administrator efficiency in the construction draw process.</h2>
            <span className="specialty-label">BUILT TECHNOLOGIES • 2025</span>
            <p className="subtext">The current commercial construction draw submission process is manual, fragmented, and error-prone. On average, subcontractors on a construction project can expect to wait anywhere from 30 to 90 days to get paid, after submitting their invoice.</p>
            <Link to="/case-study-1" className="btn-outline">
              <span className="btn-outline-text">Learn More</span>
            </Link>
          </div>
        </div>

        <div className="home-case-study-section">
          <div className="case-study-image">
            <div className="image-container">
              <img src={fullworkflow} alt="Case Study 2" />
            </div>
          </div>
          <div className="home-case-study-content">
            <h2>Designing a workflow builder and rules engine to support compliance-friendly construction draw disbursements.</h2>
            <span className="specialty-label">BUILT TECHNOLOGIES • 2023</span>
            <p className="subtext">Construction lending is high-touch, high-risk, and high-cost to manage. Nearly 90% of large infrastructure projects exceed their budgets—by an average of 28%—causing widespread financial leakage and delays.</p>
            <Link to="/case-study-2" className="btn-outline">
              <span className="btn-outline-text">Learn More</span>
            </Link>
          </div>
        </div>

        <div className="home-case-study-section">
          <div className="case-study-image">
            <div className="image-container">
              <img src={eComm3} alt="Case Study 3" />
            </div>
          </div>
          <div className="home-case-study-content">
            <h2>Building an e-Learning marketplace for healthcare representatives to drive Direct-to-Consumer sales.</h2>
            <span className="specialty-label">HEALTHSTREAM • 2019-2020</span>
            <p className="subtext">HealthStream offers applications, content, and solutions for developing healthcare representatives. The organization needed a better way to sell educational content direct to consumers rather than through hospital organizations (B2B).</p>
            <Link to="/case-study-3" className="btn-outline">
              <span className="btn-outline-text">Learn More</span>
            </Link>
          </div>
        </div>

        <div className="home-case-study-section">
          <div className="case-study-image">
            <div className="image-container">
              <img src={gsParts} alt="Case Study 4" />
            </div>
          </div>
          <div className="home-case-study-content">
            <h2>Reducing execution errors for Wall Street Floor Brokers through an IA system re-design of order tickets.</h2>
            <span className="specialty-label">GOLDMAN SACHS • 2019</span>
            <p className="subtext">Banking has traditionally been one of the least digital industries, with Wall Street being slower than commercial banking to embrace digital innovation.</p>
            <Link to="/case-study-4" className="btn-outline">
              <span className="btn-outline-text">Learn More</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/case-study-1" element={<CaseStudy1 />} />
        <Route path="/case-study-2" element={<CaseStudy2 />} />
        <Route path="/case-study-3" element={<CaseStudy3 />} />
        <Route path="/case-study-4" element={<CaseStudy4 />} />
      </Routes>
    </Router>
  );
}

export default App;
